export enum UserResponseUpdateUserError {
  unableToUpdateUser = 'unableToUpdateUser',
}
